import { Configurations } from './Configurations';

export function Settings() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold mb-2">Settings</h2>
        <p className="text-muted-foreground">Manage your store configurations and preferences</p>
      </div>

      <Configurations />
    </div>
  );
}
